import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MuiButtonPrimary, MuiButtonSecondary } from "../../../../components";
import { PAGE_URLS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { ViewProgramFooterWrapper } from "./ViewProgramFooter.style";

interface ViewProgramFooterProps {
  pageId: string;
  handleNavigateBack: () => void;
  handleEdit?: () => void;
  isVersionLatest?: boolean;
  isEditable?: boolean;
}

export const ViewProgramFooter: FC<ViewProgramFooterProps> = ({
  pageId,
  handleNavigateBack,
  handleEdit,
  isVersionLatest,
  isEditable,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { commonLabels } = useSiteCore();

  const onCloseButton = () => {
    handleNavigateBack();
  };

  const onEditButton = () => {
    navigate(`${PAGE_URLS.EDIT_PROGRAM}/${id}`);
  };

  return (
    <ViewProgramFooterWrapper>
      <MuiButtonSecondary id={`${pageId}-close`} onClick={onCloseButton}>
        {commonLabels.close}
      </MuiButtonSecondary>
      {isEditable && (
        <MuiButtonPrimary
          onClick={handleEdit ?? onEditButton}
          id={`${pageId}-edit`}
          disabled={!isVersionLatest}
        >
          {commonLabels.edit}
        </MuiButtonPrimary>
      )}
    </ViewProgramFooterWrapper>
  );
};
